import { get } from "lodash";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import BreadcrumbComponent, {
  PAGE_BREADCRUMB,
} from "src/components/breadcrumb";
import MenuListComponent from "src/components/menu-left";
import UserInfoComponent from "src/components/user-info";
import { getUrlParameter } from "src/utils/urlQueryHandle";
import ListTabsComponent from "./components/list-tabs";
import ReservationListTab1Component from "./components/list-buy";
import ReservationListTab2Component from "./components/list-sale";
import "./index.scss";
import { isMobile, isMobileOnly, isTablet } from "react-device-detect";
import { MinusCircleIcon } from "src/assets/icons";
import { useDispatch, useSelector } from "react-redux";
import { updateOrder } from "src/slices/reservationList";
interface IProps {
  isResale?: boolean;
}

function ReservationListComponent({ isResale }: IProps) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { order: orderType } = useSelector(
    (state: any) => state.reservationList
  );

  const listTabsComponent = useMemo(() => {
    return [
      {
        component: <ReservationListTab1Component isResale={isResale} />,
      },
      {
        component: <ReservationListTab2Component isResale={isResale} />,
      },
    ];
  }, [isResale]);

  const iQs = getUrlParameter("reservation_list_tab_active");
  const [tabs, setTabs] = useState(iQs ? Number(iQs) : 0);

  const renderLayout = useMemo(() => {
    return <>{get(get(listTabsComponent, tabs, 0), "component", null)}</>;
  }, [listTabsComponent, tabs]);

  const changeOrderClick = (order: string) => {
    dispatch(updateOrder({ order }));
  };

  const renderHeaderRight = () => {
    return (
      <div className="header-right">
        <div
          onClick={() => {
            changeOrderClick("dsc");
          }}
          className={orderType === "dsc" ? "selected" : ""}
        >
          {t("reservation_list.menu_reservation_list_order_desc")}
        </div>
        <div
          className={orderType === "asc" ? "selected" : ""}
          onClick={() => {
            changeOrderClick("asc");
          }}
        >
          {t("reservation_list.menu_reservation_list_order_asc")}
        </div>
      </div>
    );
  };

  const renderTextHeader = () => {
    return t("reservation_list.menu_reservation_list");
  };

  return (
    <div
      className={
        isMobileOnly
          ? "ReservationListStyleMobile"
          : isTablet
          ? "ReservationListStyleTablet"
          : "ReservationListStyle"
      }
    >
      <div
        style={
          isMobile
            ? {
                paddingTop: isTablet ? 36 : 42,
                paddingLeft: isTablet ? 40 : 16,
              }
            : { paddingLeft: "15%" }
        }
      >
        <div className="nafutel-layout-header">
          <BreadcrumbComponent
            page={
              PAGE_BREADCRUMB[
                isResale ? "resale_reservation_list" : "reservation_list"
              ]
            }
          />
        </div>
      </div>

      <UserInfoComponent
        containerStyle={{
          right: isMobileOnly ? "15px" : isTablet ? "40px" : "15%",
        }}
      />

      <div className="wrap-content">
        {isMobile && (
          <div className="header-left position-relative">
            {renderTextHeader()}{" "}
            <MinusCircleIcon
              style={{
                position: "absolute",
                right: isTablet ? 0 : 20,
                top: isTablet ? 0 : 16,
              }}
            />
          </div>
        )}
        {isMobile && renderHeaderRight()}

        <div className="content-left">
          <MenuListComponent isResale={isResale} />
        </div>
        <div className="content-right">
          {!isMobile && (
            <div className="header">
              <div className="header-left">{renderTextHeader()}</div>
              {renderHeaderRight()}
            </div>
          )}
          <ListTabsComponent callback={setTabs} />
          <div style={isMobile ? { paddingLeft: 10, paddingRight: 10 } : {}}>
            {renderLayout}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReservationListComponent;
